"use client"

import { useEffect } from "react"

import { initReferralCapture } from "@/lib/referral/client"

export function ReferralBootstrap() {
  useEffect(() => {
    initReferralCapture()
  }, [])

  return null
}
